/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from "react";
import { Chip, CircularProgress, Divider, FormControlLabel, Grid, Icon, IconButton, InputAdornment, Switch, } from "@mui/material";

import "./style.css";
import { Componente, ID_INVERSOR, ID_MICROINVERSOR, ID_MODULO, Inversor, Modulo, Mppt, Estabelecimento, RegiaoParametroComponente, Upload, InversorStringBox, ID_STRING_BOX, } from "../../types";
import { Componente as ComponenteClass } from "src/components/componentes/Componente";
import defaultListStore from "src/framework/store/DefaultListStore";
import { DataGridStore } from "src/framework/store/DataGridStore";
import { InputSelectSimple, InputSelectSimpleProperties, } from "src/framework/components/forms/inputs/InputSelectSimple";
import { direciton, ModuloXInversor } from "../ModuloXInversor";
import { observer } from "mobx-react";
import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE, } from "src/framework/providers/api";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import { Mppts } from "../Mppts";
import { EstabelecimentoSaida } from "../EstabelecimentoSaida";
import { Documentos } from "../Documentos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalculator, faTemperatureLow, } from "@fortawesome/free-solid-svg-icons";

import { InputSwitch } from "src/framework/components/forms/inputs/InputSwitch";
import { InputUploadImage } from "src/framework/components/forms/inputs/InputUploadImage";
import { RegioesParametros } from "../RegioesParametros";
import { resolveProtocolUrl } from "src/store/global.store";
import { notifierStore } from "src/framework/store/NotifierStore";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { InversoresStringBox } from "../InversoresStringBox";
import { InputSelectMultiple, InputSelectMultipleProperties } from "src/framework/components/forms/inputs/InputSelectMultiple";
import { InputText, InputTextParameters } from "src/framework/components/forms/inputs/InputText";
import { InputInteger } from "src/framework/components/forms/inputs/InputInteger";
import { InputDecimal } from "src/framework/components/forms/inputs/InputDecimal";
import { InputSelectRegioes } from "src/framework/components/forms/inputs/InputSelectRegioes";
import { Regiao } from "src/types";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";
import { AtributosDef, Enum, SUBTIPO_ATRIBUTO, TIPO_ATRIBUTO } from "src/framework/commons/types";
import { ComponentUtil } from "src/framework/commons/ComponentUtil";
import { ErrorValidate } from "src/components/pagamento/types";

export interface DocumentosComponentes {
  imagem: Upload | null;
  datasheet: Upload | null;
  procel: Upload | null;
  fabricante: Upload | null;
  inmetro: Upload | null;
  manual: Upload | null;
  simulacao: Upload | null;
}

export const DEFAULT_VALUES: Componente = {
  id: "",
  nome: "",
  nome_comercial: "",
  modelo: "",
  descricao: "",
  descricao_comercial: "",
  tempo_garantia: "",
  tempo_garantia_unidade: "",
  grupo_mercadoria: "",
  considerar_calculo: false,
  exibir_listagem: false,
  fabricante: "",
  peso: "",
  comprimento: "",
  seguimento: "",
  largura: "",
  altura: "",
  dados_integracao: undefined,
  atributos: "",
  regioes: [],
  regioes_parametros: [],
  categoria_componentes_id: undefined,
  categoria: "",
  estabelecimentos:
    defaultListStore?.estabelecimentos.map((e) => {
      return {
        componente_substituto_id: null,
        considerar_calculo: false,
        expedicao: true,
        minimo: 0,
        estabelecimento_id: e.id,
      };
    }) || [],
};

export interface BaseFormProperties {
  row: any;
  store: DataGridStore;
  onCancel?: Function;
  callEdit?: Function;
}

export enum grupoRegioes {
  REGIOES = "Região",
  ESTADOS = "Estado",
  OUTROS = "Outros",
}

interface ErrorState {
  peso: ErrorValidate
  altura: ErrorValidate
  largura: ErrorValidate
  comprimento: ErrorValidate
}

const INITIAL_ERROR_STATE: ErrorState = {
  peso: {
    hasError: false,
    hintText: ""
  },
  altura: {
    hasError: false,
    hintText: ""
  },
  largura: {
    hasError: false,
    hintText: ""
  },
  comprimento: {
    hasError: false,
    hintText: ""
  },
}

const BaseForm: FC<BaseFormProperties> = observer(
  (props: BaseFormProperties) => {
    const { store } = props;
    const Componente: ComponenteClass = new ComponenteClass(api, apiNoLoading);

    const [fitHeigth, setFitHeigth] = React.useState<number>(0);
    const [loadingDocs, setLoadingDocs] = React.useState<boolean>(false);
    const [loadingImag, setLoadingImg] = React.useState<boolean>(false);
    const [progressImg, setProgressImg] = React.useState<number | undefined>(undefined);

    const [formState, setFormState] = React.useState({
      ...DEFAULT_VALUES,
      ...props.row,
    });
    const [tabDados, setTabDados] = React.useState("dados-calculo");
    const [regioesSelecionadas, setRegioesSelecionadas] = React.useState([
      ...(formState?.regioes || []),
    ]);
    const [atributosDef, setAtributosDef] = React.useState<AtributosDef[]>([]);
    const [calculandoState, setCalculandoState] = React.useState<any>({
      MODULO_TENSAO_VOC: false,
    });

    const [documentos, setDocumentos] = React.useState<DocumentosComponentes>({
      datasheet: null,
      imagem: null,
      procel: null,
      fabricante: null,
      inmetro: null,
      manual: null,
      simulacao: null,
    });

    const [componentesList, setComponentesList] = useState<Componente[]>([]);

    const [errorState, setErrorState] = useState<ErrorState>(INITIAL_ERROR_STATE);

    const [imgState, setImgState] = useState<string>("");

    const [regioesParametros, setRegioesParametros] = useState<RegiaoParametroComponente[]>([]);

    const validate = (): boolean => {
      const errorMessages: string[] = []
      const errors = { ...errorState }
      if (formState.peso.toString() === "") {
        errorMessages.push(`O campo "peso" na aba Logística é obrigatório!`)
        errors.peso = { hasError: true, hintText: "" }
      }

      if (parseFloat(formState.peso.toString()) < 0) {
        errorMessages.push(`O campo "peso" na aba Logística deve ser maior que 0 (zero)!`)
        errors.peso = { hasError: true, hintText: "" }
      }

      if (formState.altura.toString() === "") {
        errorMessages.push(`O campo "altura" na aba Logística é obrigatório!`)
        errors.altura = { hasError: true, hintText: "" }
      }

      if (parseFloat(formState.altura.toString()) === 0) {
        errorMessages.push(`O campo "altura" na aba Logística deve ser maior que 0 (zero)!`)
        errors.altura = { hasError: true, hintText: "" }
      }

      if (formState.largura.toString() === "") {
        errorMessages.push(`O campo "largura" na aba Logística é obrigatório!`)
        errors.largura = { hasError: true, hintText: "" }
      }

      if (parseFloat(formState.largura.toString()) === 0) {
        errorMessages.push(`O campo "largura" na aba Logística deve ser maior que 0 (zero)!`)
        errors.largura = { hasError: true, hintText: "" }
      }

      if (formState.comprimento.toString() === "") {
        errorMessages.push(`O campo "comprimento" na aba Logística é obrigatório!`)
        errors.comprimento = { hasError: true, hintText: "" }
      }

      if (parseFloat(formState.comprimento.toString()) === 0) {
        errorMessages.push(`O campo "comprimento" na aba Logística deve ser maior que 0 (zero)!`)
        errors.comprimento = { hasError: true, hintText: "" }
      }

      if (errorMessages.length > 0) {
        setErrorState({ ...errors })
        notifierStore.setNotifier({
          title: "Aviso",
          content: errorMessages,
          timeOut: 3500,
          onClose: () => {
            notifierStore.setOpen(false)
          }
        })
        notifierStore.setOpen(true)

        return false
      }


      return true
    }

    const getComponentesByCategoria = async (categorias: number[]): Promise<Componente[]> => {
      let componentes: Componente[] = [];

      const request: IDataRequest = {
        url: "/componentes/cache?includes=atributos&categoria_componentes_id_in=" + categorias.join(",")
      }

      const response: IDataResponse = await apiNoLoading.get(request);

      if (response.statusCode === STATUS_CODE.OK) {
        componentes = response.data;
      }

      return componentes;
    }

    useEffect(() => {
      setFitHeigth(ComponentUtil.fitHeigthSize("#componente-form-container"));

      setInversoresStringBoxState(formState?.inversores_stringbox || [])

      defaultListStore.loadAtributosComponentes().then((respAtributos) => {
        setAtributosDef(respAtributos)
      })

      if (formState?.uploads) {
        const idxImage = formState?.uploads.findIndex((up: any) => up.tipo === 'image');
        if (idxImage > -1) {
          setImgState(resolveProtocolUrl(`//${defaultListStore.uploadUrl}${formState?.uploads[idxImage].url}?r=${Math.floor(Math.random() * 100) + 1}`))
        }
      }

      if (formState?.regioes_parametros) {
        setRegioesParametros(formState.regioes_parametros);
      }

    }, []);

    useEffect(() => {
      setFormState(formState);

      if (!formState.estabelcimentos) {
        const estabelecimentos = defaultListStore?.estabelecimentos.map((e) => {
          return {
            componente_substituto_id: null,
            considerar_calculo: false,
            expedicao: true,
            minimo: 0,
            estabelecimento_id: e.id,
          };
        });
        setEstabelecimentos(estabelecimentos);
        if (formState.categoria_componentes_id) {

          const categorias = [ID_INVERSOR, ID_MICROINVERSOR].includes(formState.categoria_componentes_id) ? [ID_MODULO] : [ID_INVERSOR, ID_MICROINVERSOR]

          getComponentesByCategoria(categorias)
            .then((response) => {
              setComponentesList(response)
            })
        }
      }
    }, [formState]);

    const id = props?.row?.id;

    const unidadesGarantia = [
      {
        text: "Meses",
        value: "meses",
      },
      {
        text: "Anos",
        value: "anos",
      },
    ];

    const segmento = [
      {
        text: "On Grid",
        value: "on",
      },
      {
        text: "Off Grid",
        value: "off",
      },
      {
        text: "Ambos",
        value: "todos",
      },
    ];

    const tipo_venda = [
      {
        text: "Gerador",
        value: "gerador",
      },
      {
        text: "Gerador/Avulso",
        value: "gerador_avulso",
      },
      {
        text: "Avulso",
        value: "avulso",
      },
    ];

    const dynamicFunctions: any = {
      MODULO_TENSAO_VOC: () => {
        if (
          formState["id"] > 0 &&
          !!formState["categoria_componentes_id"] &&
          formState["categoria_componentes_id"] === ID_MODULO
        ) {
          if (
            formState?.atributos?.MODULO_COENFICIENTE_TEMPERATURA_MAX_VOC &&
            formState?.atributos?.MODULO_TEMSAO_VOC_STC
          ) {
            // debounce(() => {
            const request: IDataRequest = {
              url: "/componentes/calcular/tensao_voc_corrigida",
              data: {
                tensao_voc: formState?.atributos?.MODULO_TEMSAO_VOC_STC,
                coeficiente_voc:
                  formState?.atributos?.MODULO_COENFICIENTE_TEMPERATURA_MAX_VOC,
                temperatura_referencia: 25,
                temperatura_minima: 5,
              },
            };
            calculandoState.MODULO_TENSAO_VOC = true;
            setCalculandoState({ ...calculandoState });
            apiNoLoading
              .post(request)
              .then((response) => {
                if (response.statusCode === STATUS_CODE.OK) {
                  formState.atributos["MODULO_TENSAO_VOC"] =
                    response.data.tensao_voc_corrigida;
                  setFormState({ ...formState });
                }
              })
              .finally(() => {
                calculandoState.MODULO_TENSAO_VOC = false;
                setCalculandoState({ ...calculandoState });
              });
            // }, 2000);
          } else {
            notifierStore.setNotifier({
              title: "Aviso!!!",
              content:
                "Os campos 'Coef. temp. máx. (Voc)' e 'Tensão VOC (STC)' são obrigátorios",
              onClose: () => notifierStore.setOpen(false),
              timeOut: 6000,
            });
            notifierStore.setOpen(true);
          }
        }
      },
    };

    const handleChangeSwitch = (event: React.ChangeEvent<HTMLInputElement>) => {
      setFormState({ ...formState, [event.target.name]: event.target.checked });
    };

    const handleChangeSelect = (name: string, value: any) => {
      let _value = value;

      if (_value?.toString().match(/^\s*\d{1,3}(?:\.\d{3})*,\d{2}$/)) {
        _value = parseFloat(_value.replace(/\./, "").replace(/,/, "."));
      }

      setFormState({ ...formState, [name]: _value });
    };

    const handleChange = (name: string, value: any) => {
      if (name) {
        let _value = value?.target?.value || value;
        if (_value?.toString().match(/^\s*\d{1,3}(?:\.\d{3})*,\d{2}$/)) {
          _value = parseFloat(
            value?.target.value
              ?.toString()
              ?.replace(/\./, "")
              ?.replace(/,/, ".")
          );
        }
        // formState = { ...formState, [name]: _value }
        setFormState({ ...formState, [name]: _value });
      }
    };

    const handleChangeAtributos = (name: any, value: any) => {
      if (name) {
        let _value = value?.target?.value || value || name?.target?.value;
        let _name = typeof name === "string" ? name : name.target.name;

        let _state = {
          ...formState,
          atributos: {
            ...formState.atributos,
            [_name]: _value,
          },
        };

        setFormState(_state);
      }
    };

    const selectCategorias: InputSelectSimpleProperties = {
      name: "categoria_componentes_id",
      label: "Categoria",
      list: defaultListStore.categoriaComponente.map((item) => {
        return { value: item.id, text: item.nome };
      }),
      value: formState?.categoria_componentes_id || "",
      disabled: id > 0,
      onChange: (e: any) => {
        handleChangeSelect("categoria_componentes_id", e);
      },
    };

    const selectFabricante: InputSelectSimpleProperties = {
      name: "fabricante_id",
      label: "Fabricante",
      list: defaultListStore.fabricantes.map((item) => {
        return { value: item.id, text: item.nome };
      }),
      value: formState?.fabricante_id || "",
      // disabled: id > 0,
      onChange: (e: any) => {
        handleChangeSelect("fabricante_id", e);
      },
    };

    const selectUnidadeTempoGarantia: InputSelectSimpleProperties = {
      name: "tempo_garantia_unidade",
      label: "Un. tempo de garantia",
      list: unidadesGarantia,
      value: formState?.tempo_garantia_unidade,
      onChange: (e: any) => {
        handleChangeSelect("tempo_garantia_unidade", e);
      },
    };


    const modulosInversores: Modulo[] | Inversor[] =
      [ID_MODULO].indexOf(formState.categoria_componentes_id) > -1
        ? formState?.inversores || []
        : [ID_INVERSOR, ID_MICROINVERSOR].indexOf(
          formState.categoria_componentes_id
        ) > -1
          ? formState?.modulos || []
          : [];

    const [modulosInversoresState, setModulosInversoresState] =
      useState(modulosInversores);

    const [inversoresStringBoxState, setInversoresStringBoxState] =
      useState<InversorStringBox[]>([]);

    const moduloInversorKey: string = [ID_MODULO].includes(
      formState.categoria_componentes_id
    )
      ? "inversor_id"
      : "modulo_id";

    const doSave = async (): Promise<void> => {
      const row = { ...formState };
      const modulosInversoresField =
        moduloInversorKey === "modulo_id" ? "modulos" : "inversores";
      const { data: newRegioes, removedData: removedRegioes } = ComponentUtil.getListPersist(
        formState.regioes || [],
        regioesSelecionadas,
        "regiao_id"
      );

      row.regioes = [
        ...newRegioes,
        ...removedRegioes.map((e: any) => {
          e["@remove"] = true;
          return e;
        }),
      ];

      if (formState?.inversores_stringbox?.length > 0 || inversoresStringBoxState.length > 0) {

        const { data: newStringBox, removedData: removedStringbox } = ComponentUtil.getListPersist(
          formState.inversores_stringbox || [],
          inversoresStringBoxState,
          "inversor_id"
        );

        row.inversores_stringbox = [
          ...newStringBox,
          ...removedStringbox.map((e: any) => {
            e["@remove"] = true;
            return e;
          }),
        ];
      }


      preSaveModulosInversores(
        modulosInversoresState,
        moduloInversorKey,
        row,
        modulosInversoresField
      );

      if (estabelecimentos.length > 0) {
        let oneCheckedExpedicao = false;
        row.estabelecimentos = estabelecimentos.map((e) => {
          if (!oneCheckedExpedicao) {
            oneCheckedExpedicao = e.expedicao ? e.expedicao : false;
          }

          const _estabelecimento: any = {
            estabelecimento_id: e.estabelecimento_id,
            componente_substituto_id: e.componente_substituto_id,
            considerar_calculo: e.considerar_calculo,
            expedicao: e.expedicao,
            minimo: e.minimo,
          };
          return _estabelecimento;
        });

        if (!oneCheckedExpedicao) {
          notifierStore.setNotifier({
            title: "Aviso!!!",
            content:
              "É necessário que pelo menos um estabelecimento tenha o campo 'expedição' marcado!",
            timeOut: 3500,
            onClose: () => {
              notifierStore.setOpen(false);
            },
          });
          notifierStore.setOpen(true);
          return;
        }
      }

      let rowToSave = { ...row };
      setFormState({ ...rowToSave });

      if (rowToSave?.modulos?.length === 0) {
        delete rowToSave.modulos;
      }

      if ([ID_INVERSOR, ID_MICROINVERSOR].includes(rowToSave.categoria_componentes_id)) {
        rowToSave.mppt = mppts;
      }


      if (regioesParametros.length > 0) {
        rowToSave.regioes_parametros = [...regioesParametros]
      }


      if (rowToSave?.mppt?.length === 0) {
        delete rowToSave.mppt;
      }

      if (rowToSave?.estabelcimentos?.length === 0) {
        delete rowToSave.estabelcimentos;
      }

      if (rowToSave?.inversores?.length === 0) {
        delete rowToSave.inversores;
      }

      if (rowToSave?.regioes?.length === 0) {
        delete rowToSave.regioes;
      }


      if (
        documentos.datasheet !== null
        || documentos.imagem !== null
        || documentos.procel !== null
        || documentos.fabricante !== null
        || documentos.inmetro !== null
        || documentos.manual !== null
      ) {
        const uploads = [];

        if (documentos.datasheet) {
          uploads.push(documentos.datasheet);
        }

        if (documentos.imagem) {
          uploads.push(documentos.imagem);
        }

        if (documentos.procel) {
          uploads.push(documentos.procel);
        }

        if (documentos.fabricante) {
          uploads.push(documentos.fabricante);
        }

        if (documentos.inmetro) {
          uploads.push(documentos.inmetro);
        }


        if (documentos.manual) {
          uploads.push(documentos.manual);
        }


        if (uploads.length > 0) {
          rowToSave["uploads"] = uploads;
        }
      }

      // if (inversoresStringBoxState.length > 0) {
      //   rowToSave["inversores_stringbox"] = inversoresStringBoxState;
      // }

      const response: IDataResponse = await store.save({
        row: rowToSave,
        primaryKey: id,
      });

      if (
        [STATUS_CODE.OK, STATUS_CODE.CREATED, STATUS_CODE.NO_CONTENT].includes(
          response.statusCode
        )
      ) {
        defaultListStore.removeCache("componentes");
        defaultListStore.getComponentes();
        if (props.onCancel) {
          setFormState({ ...DEFAULT_VALUES });
          setDocumentos({
            datasheet: null,
            imagem: null,
            procel: null,
            fabricante: null,
            inmetro: null,
            manual: null,
            simulacao: null,
          });
          setMppts([]);
          setEstabelecimentos([]);
          props.onCancel();
        }
      }
    };

    const findNew = async (codigoItem: string): Promise<void> => {
      if (codigoItem === "") {
        return;
      }

      const responseComponentes: IDataResponse = await store.find(codigoItem);

      if (responseComponentes) {
        notifierStore.setNotifier({
          content: "Já existe um componente cadastrado com esse código!",
          title: "Aviso!!",
          timeOut: 3000,
          onClose: () => {
            if (props.callEdit) {
              props.callEdit(responseComponentes);
            }
            notifierStore.setOpen(false);
          },
        });
        notifierStore.setOpen(true);
        return;
      }

      const response: IDataResponse = await api.get({
        url: `${store.paths.read}/buscar/${codigoItem}`,
      });

      if (response.statusCode === STATUS_CODE.OK) {
        selectCategorias.list = defaultListStore.categoriaComponente.map(
          (item) => {
            return { value: item.id, text: item.nome };
          }
        );
        setFormState({ ...formState, ...response.data });
      }
    };

    const atributosIds: string[] = defaultListStore
      .atributosDefByCategoria(formState.categoria_componentes_id)
      .map((attr: AtributosDef) => attr.id);

    /*  Object.keys(formState?.atributos || {}) */

    const buildFormInputComponent = (
      attrDef: AtributosDef,
      state: any
    ): React.ReactNode => {
      const key = `componente-atributos-${formState.id}-${attrDef.id}`;

      switch (attrDef.tipo) {
        case TIPO_ATRIBUTO.TEXTO:
          if (attrDef.subtipo === SUBTIPO_ATRIBUTO.ENUM) {
            if (attrDef.multiplo) {
              const InputSelectMultipleProperties: InputSelectMultipleProperties =
              {
                fullWidth: true,
                label: attrDef.titulo,
                value: state?.atributos
                  ? state?.atributos[attrDef.id].split(",") || []
                  : [],
                list:
                  attrDef?.valores?.enum?.map((item: Enum) => {
                    let text = item?.text || item.value.toString();
                    return {
                      value: item.value.toString(),
                      text: text,
                    };
                  }) || [],
                sufix: attrDef.sufixo,
                onChange: (e: any): void => {
                  handleChangeAtributos(attrDef.id, e);
                },
              };
              return (
                <InputSelectMultiple
                  {...InputSelectMultipleProperties}
                  key={key}
                />
              );
            }
            const _list =
              attrDef?.valores?.enum?.map((item: Enum) => {
                let text = item?.text || item.value.toString();
                return {
                  value: item.value,
                  text: text,
                };
              }) || [];
            const InputSelectProperties: InputSelectSimpleProperties = {
              fullWidth: true,
              name: attrDef.id,
              label: attrDef.titulo,
              value: state?.atributos ? state?.atributos[attrDef.id] || "" : "",
              list: _list,
              sufix: attrDef.sufixo,
              margin: "normal",
              onChange: (e: any): void => {
                handleChangeAtributos(attrDef.id, e);
              },
            };
            return <InputSelectSimple {...InputSelectProperties} key={key} />;
          }
          const inputTextProps: InputTextParameters = {
            fullWidth: true,
            name: attrDef.id,
            label: attrDef.titulo,
            margin: "normal",
            value: state?.atributos ? state?.atributos[attrDef.id] || "" : "",
            onChange: (e: any): void => {
              handleChangeAtributos(attrDef.id, e);
            },
          };
          return <InputText {...inputTextProps} />;
        case TIPO_ATRIBUTO.INTEIRO:
          if (attrDef.subtipo && attrDef.subtipo === SUBTIPO_ATRIBUTO.ENUM) {
            if (attrDef.multiplo) {
              let value = [];
              if (Object.keys(state?.atributos || []).includes(attrDef.id)) {
                value = state?.atributos[attrDef.id];
              }

              if (!Array.isArray(value)) {
                value = value?.toString()?.split(",") || [];
              }

              const InputSelectMultipleProperties: InputSelectMultipleProperties =
              {
                fullWidth: true,
                label: attrDef.titulo,
                value: value,
                list:
                  attrDef?.valores?.enum?.map((item: Enum) => {
                    let text = item?.text || item.value.toString();
                    return {
                      value: item.value.toString(),
                      text: text,
                    };
                  }) || [],
                sufix: attrDef.sufixo,
                margin: "normal",
                onChange: (e: any): void => {
                  handleChangeAtributos(attrDef.id, e);
                },
              };
              return (
                <InputSelectMultiple
                  {...InputSelectMultipleProperties}
                  key={key}
                />
              );
            }
            const _list =
              attrDef?.valores?.enum?.map((item: Enum) => {
                let text = item?.text || item.value.toString();
                return {
                  value: item.value,
                  text: text,
                };
              }) || [];

            const InputSelectProperties: InputSelectSimpleProperties = {
              fullWidth: true,
              name: attrDef.id,
              label: attrDef.titulo,
              value: state?.atributos ? state?.atributos[attrDef.id] || "" : "",
              list: _list,
              sufix: attrDef.sufixo,
              margin: "normal",
              onChange: (e: any): void => {
                handleChangeAtributos(attrDef.id, e);
              },
            };

            return <InputSelectSimple {...InputSelectProperties} key={key} />;
          }

          return (
            <InputInteger
              fullWidth={true}
              name={attrDef.id}
              id={`${attrDef.id}-${formState.id}`}
              label={`${attrDef.titulo}`}
              value={state?.atributos ? state?.atributos[attrDef.id] || 0 : 0}
              maxLength={attrDef.tamanho}
              onChangeValue={(name: string, value: any) => {
                handleChangeAtributos(name, value)
              }}
              sufix={attrDef.sufixo}
              margin="normal"
              allowNegative={attrDef.aceitar_negativo}
              disabled={attrDef.calculado}
              key={key}
            />
          );

        case TIPO_ATRIBUTO.DECIMAL:
          if (attrDef.subtipo === SUBTIPO_ATRIBUTO.ENUM) {
          }

          return (
            <InputDecimal
              fullWidth={true}
              name={attrDef.id}
              label={`${attrDef.titulo}`}
              value={state?.atributos ? state?.atributos[attrDef.id] : 0}
              decimal={attrDef.precisao}
              maxLength={attrDef.tamanho}
              onChange={handleChangeAtributos}
              margin="normal"
              disabled={calculandoState[`${attrDef.id}`] || false}
              sufix={attrDef.sufixo}
              prefix={
                attrDef.calculado ? (
                  <InputAdornment position="start">
                    <IconButton
                      disabled={calculandoState[`${attrDef.id}`]}
                      size="small"
                      onClick={() => {
                        if (dynamicFunctions[`${attrDef.id}`]) {
                          dynamicFunctions[`${attrDef.id}`]();
                        }
                      }}
                    >
                      {calculandoState[`${attrDef.id}`] ? (
                        <CircularProgress size="20px" variant="indeterminate" />
                      ) : (
                        <FontAwesomeIcon icon={faCalculator} size="sm" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ) : null
              }
              key={key}
            />
          );

        case TIPO_ATRIBUTO.LOGICO:


          return <InputSwitch
            value={state?.atributos ? state?.atributos[attrDef.id] || false : false}
            label={attrDef.titulo}
            margin="normal"
            onChangeValue={(value: boolean, name: string) => {
              handleChangeAtributos(attrDef.id, value);
            }}
          />;
      }

      return "";
    };

    const [mppts, setMppts] = useState<Mppt[]>(formState?.mppt || []);
    const [estabelecimentos, setEstabelecimentos] = useState<Estabelecimento[]>([]);


    const addMppt = (mppt: Mppt): void => {
      setMppts([...mppts, mppt]);
    };

    const removeMppt = (numero: number): void => {
      let _mppts: Mppt[] = mppts.filter((m) => numero !== m.numero);

      for (let idx in _mppts) {
        _mppts[idx].numero = parseInt(idx) + 1;
      }
      setMppts([..._mppts]);
    };

    return (
      <section
        id="componente-form-container"
        style={{ height: `${fitHeigth}px`, marginBottom: "70px" }}
      >
        <Grid container spacing={1}>
          <Grid size={12}>
            <h4 style={{ textAlign: "left" }}>Dados gerais</h4>
            <Divider />
          </Grid>

          <Grid container size={12} spacing={1}>
            <Grid size={{ xs: 12, md: 2 }}>
              <InputUploadImage
                progress={progressImg}
                id={Number(formState?.id)}
                url={imgState}
                downloadName={`imagem_componente-${formState?.modelo}`}
                onHandleUpload={(id: number, file: File) => {
                  setLoadingImg(true)
                  Componente.uploadImage({ codigoComponente: String(id), file: file, tipo: "image", onProgress: (_progress) => { setProgressImg(_progress) } }).then((data) => {
                    const state: any = { ...formState }
                    const idxUpload: number = formState?.uploads?.findIndex((up: Upload) => up.tipo === "image");
                    if (idxUpload) {
                      state.uploads[idxUpload] = data?.url;
                      setFormState(state);
                    }

                    documentos.imagem = data;
                    setDocumentos(documentos);
                  }).finally(() => {
                    setLoadingImg(false);
                  })
                }}
                onHandleRemove={() => {

                  confirmationDialog.setup({
                    title: "Aviso!!!",
                    content: `Deseja remover a imagem do componente?`,
                    onClose: () => {
                      confirmationDialog.close();
                    },
                    onNegation: () => {
                      if (formState?.uploads) {
                        const idxImage = formState?.uploads.findIndex((up: any) => up.tipo === 'image');
                        if (idxImage > -1) {
                          setImgState(resolveProtocolUrl(`//${defaultListStore.uploadUrl}${formState?.uploads[idxImage].url}?r=${Math.floor(Math.random() * 100) + 1}`))
                        }
                      }
                    },
                    onConfirmation: () => {
                      documentos.imagem = {
                        "@remove": true,
                        tipo: "image",
                        url: ""
                      }
                      setDocumentos(documentos);
                      confirmationDialog.close();
                    }
                  })
                  confirmationDialog.open()
                }}
                key={`componente-documentos-upload-imagem-${formState?.codigo}`}
                style={{
                  marginBottom: "8px"
                }}
              />
            </Grid>

            <Grid container size={{ xs: 12, md: 10 }} style={{ gap: "0px 5px " }} alignItems="flex-end">
              <Grid size={{ xs: 12, md: 2 }} >
                <InputText
                  label={"Código"}
                  fullWidth={true}
                  value={formState?.id?.toString()}
                  name={"id"}
                  onChange={(e: any) => handleChange("id", e.target.value)}
                  disabled={id > 0}
                  sufix={
                    <IconButton
                      size={"small"}
                      disabled={id > 0}
                      onClick={() => {
                        findNew(formState.id.toString());
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, md: 3 }}>
                <InputSelectSimple {...selectCategorias} />
              </Grid>

              <Grid size={{ xs: 12, md: 3 }}>
                <InputText
                  label={"Nome"}
                  fullWidth={true}
                  value={formState?.nome}
                  name={"nome"}
                  onChange={(e: any) => handleChange("nome", e.target.value)}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 3 }}>
                <InputText
                  label={"Modelo"}
                  fullWidth={true}
                  value={formState?.modelo}
                  name={"modelo"}
                  onChange={(e: any) => handleChange("modelo", e.target.value)}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <InputText
                  label={"Descrição"}
                  fullWidth={true}
                  value={formState?.descricao}
                  name={"descricao"}
                  onChange={(e: any) => handleChange("descricao", e.target.value)}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 3 }}>
                <InputText
                  label={"Nome comercial"}
                  fullWidth={true}
                  value={formState?.nome_comercial}
                  name={"nome_comercial"}
                  onChange={(e: any) => handleChange("nome_comercial", e.target.value)}
                />
              </Grid>
              <Grid size={{ xs: 12, md: 4 }}>
                <InputText
                  label={"Descrição comercial"}
                  fullWidth={true}
                  value={formState?.descricao_comercial}
                  name={"descricao_comercial"}
                  onChange={(e: any) => handleChange("descricao_comercial", e.target.value)}
                />
              </Grid>



            </Grid>
            <Grid container size={12} style={{ gap: "0px 5px " }} alignItems="stretch">
              <Grid size={{ xs: 12, md: 3 }}>
                <InputSelectSimple {...selectFabricante} />
              </Grid>
              <Grid size={{ xs: 6, md: 2 }}>
                <InputInteger
                  label={"Tempo de garantia"}
                  fullWidth={true}
                  maxLength={3}
                  value={formState?.tempo_garantia?.toString()}
                  name={"tempo_garantia"}
                  onChangeValue={(e: any, value: any) =>
                    handleChange("tempo_garantia", value)
                  }
                />
              </Grid>
              <Grid size={{ xs: 6, md: 2 }}>
                <InputSelectSimple {...selectUnidadeTempoGarantia} />
              </Grid>
              <Grid size={{ xs: 6, md: 2 }}>
                <InputSelectSimple
                  name="segmento"
                  label="Segmento"
                  list={segmento}
                  value={formState?.segmento || ""}
                  onChange={(e: any) => handleChangeSelect("segmento", e)}
                />
              </Grid>
              <Grid size={{ xs: 6, md: 2 }}>
                <InputSelectSimple
                  name="venda"
                  label="Tipo venda"
                  list={tipo_venda}
                  value={formState?.venda || ""}
                  onChange={(e: any) => handleChangeSelect("venda", e)}
                />
              </Grid>
              <Grid size={{ xs: 6, md: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formState.considerar_calculo}
                      onChange={handleChangeSwitch}
                      name="considerar_calculo"
                      color="primary"
                    />
                  }
                  label="Considerar cálculo"
                />
              </Grid>
              <Grid size={{ xs: 6, md: 2 }} alignItems="center">
                <FormControlLabel
                  control={
                    <Switch
                      checked={formState.exibir_listagem}
                      onChange={handleChangeSwitch}
                      name="exibir_listagem"
                      color="primary"
                    />
                  }
                  label="Exibir na listagem"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <div className="row">
          <div className="X12">
            <Divider />
          </div>
          <div className="X12">
            <TabControl
              currentTabName={tabDados}
              onChangeTab={(e) => {
                setTabDados(e);
              }}
              key={`tabs-complementos-${formState.id}`}
            >
              <TabContent
                name={"dados-calculo"}
                label={"Dados cálculo"}
                visible={atributosIds.length > 0}
                key={`tabs-dados-calculo-${formState.id}`}
              >
                {atributosIds.length > 0 ? (
                  <section hidden={tabDados !== "dados-calculo"}>
                    <div className="row">
                      {atributosIds?.map((attrId: string, index: number) => {
                        const _attr = atributosDef.find(
                          (attr: AtributosDef) => attr.id === attrId
                        );

                        return _attr ? (
                          <div className="X12 M3" key={index}>
                            {buildFormInputComponent(_attr, formState)}
                          </div>
                        ) : null;
                      })}
                    </div>
                    {formState.categoria_componentes_id === ID_MODULO ? (
                      <div
                        className="row X-start"
                        hidden={formState.categoria_componentes_id !== ID_MODULO}
                      >
                        <div className="X12">
                          {defaultListStore.atributosDef
                            .filter((a) => {
                              return (
                                a.entidade === "parametros" &&
                                a.entidade_codigo === "componentes"
                              );
                            })
                            .map((c) => {
                              return (
                                <Chip
                                  style={{ margin: "5px 7px" }}
                                  key={`parameters-componente-${c.id}`}
                                  label={
                                    <>
                                      <FontAwesomeIcon
                                        icon={faTemperatureLow}
                                        color="orange"
                                      />
                                      {` ${c.titulo}: `}
                                      <strong>
                                        {c.valor_padrao} {c.sufixo}
                                      </strong>
                                    </>
                                  }
                                  color="default"
                                />
                              );
                            })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </section>
                ) : (
                  ""
                )}
              </TabContent>
              <TabContent
                name={"logistica"}
                label={"Logística"}
                visible={true}
                key={`tabs-logistica-${formState.id}`}
              >
                <section hidden={tabDados !== "logistica"}>
                  <div className="row">
                    <div className="X12 M2">
                      <InputDecimal
                        label={"Peso"}
                        fullWidth={true}
                        sufix={"Kg"}
                        decimal={3}
                        maxLength={11}
                        value={formState?.peso?.toString()}
                        margin={"normal"}
                        name={"peso"}
                        onChange={(e: any) => handleChange("peso", e.target.value)}
                        error={errorState.peso.hasError}
                        onFocus={() => {
                          setErrorState({ ...errorState, peso: { hasError: false, hintText: "" } })
                        }}
                      />
                    </div>
                    <div className="X12 M2">
                      <InputDecimal
                        label={"Altura"}
                        fullWidth={true}
                        sufix={"mm"}
                        decimal={3}
                        maxLength={11}
                        value={formState?.altura?.toString()}
                        margin={"normal"}
                        name={"altura"}
                        onChange={(e: any) => handleChange("altura", e.target.value)}
                        error={errorState.altura.hasError}
                        onFocus={() => {
                          setErrorState({ ...errorState, altura: { hasError: false, hintText: "" } })
                        }}
                      />
                    </div>
                    <div className="X12 M2">
                      <InputDecimal
                        label={"Largura"}
                        fullWidth={true}
                        sufix={"mm"}
                        decimal={3}
                        maxLength={11}
                        value={formState?.largura?.toString()}
                        margin={"normal"}
                        name={"largura"}
                        onChange={(e: any) => handleChange("largura", e.target.value)}
                        error={errorState.largura.hasError}
                        onFocus={() => {
                          setErrorState({ ...errorState, largura: { hasError: false, hintText: "" } })
                        }}
                      />
                    </div>
                    <div className="X12 M2">
                      <InputDecimal
                        label={"Comprimento"}
                        fullWidth={true}
                        sufix={"mm"}
                        decimal={3}
                        maxLength={11}
                        value={formState?.comprimento?.toString()}
                        margin={"normal"}
                        name={"comprimento"}
                        onChange={(e: any) => handleChange("comprimento", e.target.value)}
                        error={errorState.comprimento.hasError}
                        onFocus={() => {
                          setErrorState({ ...errorState, comprimento: { hasError: false, hintText: "" } })
                        }}
                      />
                    </div>
                  </div>
                </section>
              </TabContent>
              <TabContent
                name={"documentos"}
                label={<>Documentos{loadingDocs ? <> <CircularProgress size={16} color="secondary" /></> : ""}</>}
                visible={true}
                key={`tabs-documentos-${formState.id}`}
              >
                <section hidden={tabDados !== "documentos"}>
                  <Documentos
                    codigoComponente={formState?.id || 0}
                    datasheet={formState?.uploads?.filter((up: Upload) => up.tipo === "datasheet")[0] || null}
                    procel={formState?.uploads?.filter((up: Upload) => up.tipo === "procel")[0] || null}
                    fabricante={formState?.uploads?.filter((up: Upload) => up.tipo === "fabricante")[0] || null}
                    inMetro={formState?.uploads?.filter((up: Upload) => up.tipo === "inmetro")[0] || null}
                    manualInstalacao={formState?.uploads?.filter((up: Upload) => up.tipo === "manual")[0] || null}
                    arquivoSimulacao={formState?.uploads?.filter((up: Upload) => up.tipo === "simulacao")[0] || null}
                    onLoading={(loading: boolean): void => {
                      setLoadingDocs(loading)
                    }}

                    onChangeDatasheet={(datasheetData: Upload) => {
                      documentos.datasheet = datasheetData;
                      setDocumentos(documentos);
                    }}

                    onChangeProcel={(procelData: Upload) => {
                      documentos.procel = procelData;
                      setDocumentos(documentos);
                    }}
                    onChangeFabricante={(fabricanteData: Upload) => {
                      documentos.fabricante = fabricanteData;
                      setDocumentos(documentos);
                    }}
                    onChangeInMetro={(inMetroData: Upload) => {
                      documentos.inmetro = inMetroData;
                      setDocumentos(documentos);
                    }}
                    onChangeManualInstalacao={(manualInstalacaoData: Upload) => {
                      documentos.manual = manualInstalacaoData;
                      setDocumentos(documentos);
                    }}
                    onChangeArquivoSimulacao={(simulacaoData: Upload) => {
                      documentos.simulacao = simulacaoData;
                      setDocumentos(documentos);
                    }}
                  />
                </section>
              </TabContent>
              <TabContent
                name={"regioes"}
                label={"Regiões"}
                visible={true}
                key={`tabs-regioes-${formState.id}`}
              >
                <section hidden={tabDados !== "regioes"}>
                  <div className="row">
                    <div
                      className="X12 M6"
                      style={{ paddingTop: "10px", paddingBottom: "10px" }}
                    >
                      <InputSelectRegioes
                        label={"Regiões"}
                        list={defaultListStore.regioes}
                        value={regioesSelecionadas.map(
                          (reg: any) => reg.regiao_id
                        )}
                        onChange={(value) => {
                          const regioes = value.map((reg: Regiao) => {
                            return { regiao_id: reg.id };
                          });
                          setRegioesSelecionadas(regioes)
                        }}
                      />
                    </div>
                  </div>
                </section>
              </TabContent>
              <TabContent
                name={"modulo-x-inversor"}
                label={"Módulo X Inversor"}
                visible={[ID_MODULO, ID_INVERSOR, ID_MICROINVERSOR].includes(
                  formState.categoria_componentes_id
                )}
                key={`tabs-modulo-x-inversor-${formState.id}`}
              >
                {[ID_MODULO, ID_INVERSOR, ID_MICROINVERSOR].includes(
                  formState.categoria_componentes_id
                ) ? (
                  <section style={{ overflowY: "auto", overflowX: "hidden" }}>
                    <ModuloXInversor
                      list={componentesList}
                      modulosInversores={modulosInversoresState}
                      direction={
                        [ID_MODULO].includes(
                          formState.categoria_componentes_id
                        )
                          ? direciton.INVERSORES_POR_MODULO
                          : direciton.MODULOS_POR_INVERSOR
                      }
                      onChange={(selected: Modulo[] | Inversor[]) => {
                        setModulosInversoresState(selected);
                      }}
                    />
                  </section>
                ) : (
                  ""
                )}
              </TabContent>
              <TabContent
                name={"inversores-string-box"}
                label={"Inversores String Box"}
                visible={[ID_STRING_BOX].includes(
                  formState.categoria_componentes_id
                )}
                key={`inversores-string-box-${formState.id}`}
              >
                {[ID_STRING_BOX].includes(
                  formState.categoria_componentes_id
                ) ? (
                  <section>
                    <InversoresStringBox
                      list={defaultListStore.componentesByCategoria(ID_INVERSOR)}
                      inversoresList={inversoresStringBoxState}
                      onChange={(selecteds: InversorStringBox[]) => {
                        setInversoresStringBoxState(selecteds)
                      }}
                    />
                  </section>
                ) : (
                  ""
                )}
              </TabContent>
              <TabContent
                name={"mppts"}
                label={"MPPTs"}
                visible={[ID_INVERSOR, ID_MICROINVERSOR].includes(
                  formState.categoria_componentes_id
                )}
                key={`tabs-mppt-${formState.id}`}
              >
                <section hidden={tabDados !== "mppts"} className={"container"}>
                  {!!formState.atributos &&
                    !!formState.atributos.INVERSOR_CORRENTE_MAXIMA_MPPT ? (
                    <Mppts
                      list={mppts}
                      correnteMaximaEntradaString={
                        formState.atributos.INVERSOR_CORRENTE_MAXIMA_MPPT
                      }
                      tensaoMaximaEntrada={
                        formState.atributos.INVERSOR_TENSAO_MAXIMA_ENTRADA
                      }
                      onAdd={(mppt: Mppt) => {
                        addMppt(mppt);
                      }}
                      onUpdate={(mpptList: Mppt[]) => {
                        setMppts([...mpptList]);
                      }}
                      onRemove={(numero: number) => {
                        removeMppt(numero);
                      }}
                    />
                  ) : (
                    <p>Corrente Máxima por MPPT está com valor 0 ou inválido</p>
                  )}
                </section>
              </TabContent>
              <TabContent
                name="estabelecimento"
                label="Estabelecimento"
                visible={true}
              >
                <EstabelecimentoSaida
                  list={formState?.estabelecimentos || []}
                  listEstabelecimento={defaultListStore.estabelecimentos}
                  listComponente={defaultListStore
                    .componentesByCategoria(
                      formState?.categoria_componentes_id || 0
                    )
                    .filter((comp) => comp.id !== formState.id)}
                  onChange={(list) => {
                    setEstabelecimentos(list);
                  }}
                />
              </TabContent>
              <TabContent
                name={"regioes_parametros"}
                label={"Parâmetros Regiões"}
                visible={[ID_INVERSOR, ID_MICROINVERSOR, ID_MODULO].includes(formState.categoria_componentes_id)}
                key={`tabs-regioes-${formState.id}`}
              >
                <section hidden={tabDados !== "regioes_parametros"}>
                  <RegioesParametros
                    componenteId={formState.id}
                    parametros={regioesParametros || []}
                    onChange={(parametros: RegiaoParametroComponente[]) => {
                      setRegioesParametros([...parametros]);
                    }}
                  />
                </section>
              </TabContent>
            </TabControl>
          </div>
        </div>

        <BottomBar>
          <FullWidthButton
            text={"Cancelar"}
            color={"secondary"}
            disabled={loadingDocs || loadingImag}
            onClick={() => {
              if (props.onCancel) {
                props.onCancel();
              }
            }}
          />
          <FullWidthButton
            disableElevation={true}
            disabled={loadingDocs || loadingImag}
            text={"Salvar"}
            color={"primary"}
            variant={"contained"}
            onClick={() => {
              if (!validate()) {
                return;
              }
              doSave();
            }}
          />
        </BottomBar>
      </section >
    );
  }
);

const preSaveModulosInversores = (
  modulosInversoresState: Modulo[] | Inversor[],
  moduloInversorKey: string,
  row: any,
  modulosInversoresField: string
) => {
  const _modulosInversores = [...modulosInversoresState];
  const _modulosInversoresIds = _modulosInversores.map(
    (item: any) => item[moduloInversorKey]
  );
  const _modulosRemovidos =
    (row[modulosInversoresField] as any)?.filter((item: any) => {
      return _modulosInversoresIds.indexOf(item[moduloInversorKey]) === -1;
    }) || [];

  row[modulosInversoresField] = [
    ..._modulosInversores,
    ..._modulosRemovidos.map((item: any) => {
      return { ...item, "@remove": true };
    }),
  ];
};

export { BaseForm };
